export default "__VITE_PUBLIC_ASSET__f51cc6ed__"